module.exports = __webpack_public_path__ + "img/okx.78b87eb9.png";